import styled from "styled-components";

export const CheckoutContainer = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  min-height: 100vh;
  padding: 20px 0;
  font-family: "Work Sans";
`;

export const WhatsIncludedContainer = styled.div`
  font-size: 12px;
  background: rgb(249, 234, 239);
  color: rgb(194, 47, 96);
  border-radius: 64px;
  padding: 5px 10px;
  margin-left: 10px;
`;

export const TitleH1 = styled.h1`
  font-size: ${(props) => props.theme.fontSize["4xl"]};
  color: ${(props) => props.theme.colors.textPrimary};
  font-weight: 500;
`;

export const TitleH2 = styled.h2`
  font-size: ${(props) => props.theme.fontSize["3xl"]};
  color: ${(props) => props.theme.colors.textPrimary};
  font-weight: 500;
`;

export const TitleH3 = styled.h3`
  font-size: ${(props) => props.theme.fontSize["2xl"]};
  color: ${(props) => props.theme.colors.textPrimary};
  font-weight: 500;
`;

export const TitleH4 = styled.h4<{ maj?: boolean; bold?: boolean; colorGreen?: boolean }>`
  font-size: ${(props) => props.theme.fontSize["xl"]};
  text-transform: ${(props) => (props.maj ? "uppercase" : "none")};
  font-weight: ${(props) => (props.bold ? "600" : "400")};
  line-height: 23px;
  color: ${(props) => (props.colorGreen ? props.theme.colors.primary : props.theme.colors.text)};
`;

export const TitleH5 = styled.h5<{ maj?: boolean; bold?: boolean }>`
  font-size: ${(props) => props.theme.fontSize["lg"]};
  text-transform: ${(props) => (props.maj ? "uppercase" : "none")};
  letter-spacing: 0.1px;
  line-height: 21px;
  font-weight: ${(props) => (props.bold ? "600" : "400")};
`;

export const Text = styled.p`
  font-size: ${(props) => props.theme.fontSize.base};
  line-height: 20px;
`;

export const Space = styled.div<{ height: string }>`
  height: ${(props) => props.height}px;
`;

export const Questions = styled.div`
  margin-bottom: 10px;
  font-size: ${(props) => props.theme.fontSize.lg};
  font-weight: 500;
  display: flex;
  align-items: center;
`;

export const AddonContainer = styled.div<{ isActive: boolean }>`
  /* background: ${(props) => (props.isActive ? props.theme.colors.primary : "#fff")}; */
  background: #fff;
  /* border: 2px solid ${(props) => (props.isActive ? props.theme.colors.primary : "#e6e6e6")}}; */
  padding: 20px;
  box-shadow: 0px 0px 1px 0px #0000003d;
  border-radius: 5px;
  /* display: flex; */
  /* align-items: center; */
  &:hover {
    cursor: pointer;
    border-color: ${(props) => props.theme.colors.primary};
  }
`;
export const AddonTitle = styled(TitleH5)`
  font-size: ${(props) => props.theme.fontSize.lg};
  font-weight: 600;
`;
export const AddonHeader = styled.div`
  display: flex;
  align-items: center;

  /* margin-bottom: 5px; */
`;

export const AddonButton = styled.button<{ isActive?: boolean }>`
  color: ${(props) => props.theme.colors.primary};
  border: 2px solid #fff;
  border-radius: 50px;
  background: #fff;
  padding: 7px 10px;
  border: 2px solid ${(props) => props.theme.colors.primary};
  letter-spacing: 0.2px;
  font-weight: 600;
  margin-left: auto;
  margin-right: 10px;
  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    cursor: pointer;
  }
`;

export const AddonDescription = styled(Text)`
  /* color: #909090; */
  font-size: ${(props) => props.theme.fontSize.base};
  line-height: 21px;
`;
export const AddonLearnMore = styled.a`
  display: block;
  text-decoration: underline;
  margin-top: 13px;
  color: ${(props) => props.theme.colors.primary};
  font-size: ${(props) => props.theme.fontSize.small};
  text-align: right;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`;
export const AddonPrice = styled.div`
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary};
`;

export const ExhibitorPackageContainer = styled.div<{ isActive: boolean }>`
  /* background: ${(props) => (props.isActive ? props.theme.colors.primary : "#fff")}; */
  background: #fff;
  border: 1px solid ${(props) => (props.isActive ? props.theme.colors.primary : "#e6e6e6")}};
  padding: 20px 25px 25px 15px;
  box-shadow: 0px 0px 1px 0px #0000003d;
  border-radius: 5px;
  display: flex;
  /* align-items: center; */
  &:hover {
    cursor: pointer;
    border-color: ${(props) => props.theme.colors.primary};
  }
`;
export const ExhibitorPackageTitle = styled(TitleH5)`
  font-size: ${(props) => props.theme.fontSize.lg};
  font-weight: 600;
`;
export const ExhibitorPackageHeader = styled.div`
  display: flex;
  align-items: center;

  /* margin-bottom: 5px; */
`;

export const ExhibitorPackageLeft = styled.div`
  width: 95%;
`;
export const ExhibitorPackageRight = styled.div`
  display: flex;
  justify-content: center;
  width: 5%;
  /* margin-right: 5px; */
`;

export const ExhibitorPackagePrice = styled.div`
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary};
`;

export const CGU = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: ${(props) => props.theme.fontSize.small};

  span {
    display: block;
    margin-left: 5px;
    a {
      color: ${(props) => props.theme.colors.text};
    }
  }
`;

export const NeedToLoginContainer = styled.div``;

export const Previous = styled.div`
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;

export const RequireLogin = styled.div``;
export const TitleAndToolTip = styled.div`
  display: flex;
  align-items: center;
`;

export const Plan = styled.div`
  /* box-shadow: ${(props) => props.theme.box.primary}; */
  width: 100%;
  padding: 20px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  &:hover {
    cursor: pointer;
  }
`;

export const PlanSelectRadio = styled.div`
  input {
    appearance: radio;
    margin-right: 10px;
  }
`;

export const PlanDetails = styled.div`
  width: 100%;
`;
export const PlanTitle = styled.div`
  font-weight: 500;
  font-size: ${(props) => props.theme.fontSize.lg};
`;
export const PlanSubTitle = styled.div``;
export const PlanPrice = styled.div`
  font-size: ${(props) => props.theme.fontSize.lg};
  color: ${(props) => props.theme.colors.primary};
`;

export const HowToSelectPlan = styled.div`
  border: 2px solid rgb(234, 230, 231);
  display: inline-block;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  &:hover {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    background: #fff;
  }
`;
